/* js/search.js */

;(function($, window, document) {
    
    $(document).ready(function(){
       
        $('#search-button').on('click', function(){
            $('#search').slideToggle();
        });
       
    });
    
})(jQuery, window, document);

